<template>
    <div>
        <div class="content">
            <div class="cat" style="height: 45px;">
                <div class="row align-items-center">
                    <div class="col-2 text-left d-none d-md-inline-block">
                        <router-link :to="{name:'menu.category.products', params:{id:this.$route.params.category_id}}"
                                     class="prev d-flex align-items-center">
                          <span class="material-symbols-outlined color">arrow_back_ios</span>
                        </router-link>
                    </div>
                    <div class="col-12 col-md-8" v-if="this.product">
                        {{this.product.categoria.alias}}
                    </div>
                </div>
            </div>

            <div class="content-scheda">
                <div class="scheda" v-if="this.product">
                    <div class="row">
                        <div class="col-md-6 text-center" v-if="this.graphic_layout">
                            <div class="foto">
                                <!--<img :src="this.product_image" class="img-fluid">-->
                                <div id="photo_carousel" class="carousel slide" data-ride="carousel">
                                    <!-- X DEV se c'è solo un'immagine possiamo mantenere il carosello ma dovreste nascondere l'<ol> di seguito -->
                                    <ol class="carousel-indicators" v-if="this.current_images.length > 1">
                                        <li data-target="#photo_carousel" v-for="(image, i) in this.current_images"
                                            @click="images_index = i"
                                            :data-slide-to="i" :class="{active: images_index === i}"></li>
                                    </ol>
                                    <div class="carousel-inner">
                                        <div class="carousel-item" v-for="(image, i) in this.current_images"
                                             :class="{active: images_index === i}">
                                            <img :src="image" class="img-fluid">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <inc-product-price-label v-if="this.graphic_layout" :graphic-layout="this.graphic_layout"
                                                     :currency="this.locale_currency" :product="this.product"/>
                        </div>
                        <div :class="{'col-md-6': this.graphic_layout, 'col-md-12': !this.graphic_layout}">
                            <div class="dati mb-0 p-3" :class="{'p-md-0': this.graphic_layout}">
                                <p class="nome">
                                    {{this.product.nome}}
                                </p>
                                <p class="descrizione" v-if="this.product.descrizione"
                                   v-html="this.product.descrizione.replaceAll('\n', '<br/>')">
                                </p>
                                <ul class="icone" v-if="this.product.caratteristiche.length">
                                    <li v-for="characteristic in this.product.caratteristiche">
                                        <a href="#" @click.prevent="show_modal_legend = true"
                                           v-tooltip:bottom="characteristic.nome">
                                            <img :src="getCharacteristicIcon(characteristic)">
                                        </a>
                                    </li>
                                </ul>
                                <inc-product-price-label v-if="!this.graphic_layout"
                                                         :graphic-layout="this.graphic_layout"
                                                         :currency="this.locale_currency" :product="this.product"/>
                            </div>
                        </div>

                        <div class="col-12" v-if="this.product.ingredienti.length || this.product_allergens.length">
                            <div class="dati">
                                <!-- Nav tabs -->
                                <ul class="nav nav-tabs" role="tablist">
                                    <li role="presentation" class="nav-item"
                                        :class="{active: this.current_tab === 'ingredients'}"
                                        v-if="this.product.ingredienti.length">
                                        <a href="#" @click.prevent="current_tab = 'ingredients'" aria-controls="profile"
                                           role="tab" class="nav-link">
                                            {{$t('ordine.ingredienti')}}
                                        </a>
                                    </li>
                                    <li role="presentation" class="nav-item" v-if="this.product_allergens.length"
                                        :class="{active: this.current_tab === 'allergens'}">
                                        <a href="#" @click.prevent="current_tab = 'allergens'" aria-controls="messages"
                                           role="tab" class="nav-link">
                                            {{$t('ordine.allergeni')}}
                                        </a>
                                    </li>
                                </ul>

                                <!-- Tab panes -->
                                <div class="tab-content">
                                    <div role="tabpanel" class="tab-pane"
                                         :class="{active: this.current_tab === 'ingredients'}">
                                   <span v-for="(ingredient, i) in this.product.ingredienti"
                                         :class="{'font-weight-bold': ingredient.hasOwnProperty('allergeni') && ingredient.allergeni.length}">
                                       {{ingredient.alias + (i === (product.ingredienti.length - 1) ? "" : ", ")}}
                                   </span>
                                    </div>
                                    <div role="tabpanel" class="tab-pane"
                                         :class="{active: this.current_tab === 'allergens'}">
                                      {{$t('allergeni_contenuti')}}
                                        <br>
                                        <ul class="allergeni">
                                            <li v-for="allergen in this.product_allergens">
                                                <a href="#" @click.prevent="show_modal_allergens = true">
                                                    <img :src="'/img/be/allergeni/'+allergen.icona+'.png'">
                                                    {{allergen.nome}}
                                                </a>
                                            </li>
                                        </ul>
                                        <a href="#" @click.prevent="show_modal_allergens = true"
                                           class="badge badge-pill badge-dark mb-2 mb-md-0 mt-3" style="padding: 5px 10px;">
                                          {{$t('ordine.dettagli_allergeni')}}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12" v-if="this.product.f_prodotto_composto">
                            <div class="dati pb-0" v-if="this.can_add_associated_products">
                                <button class="btn btn-block" @click="show_modal_combo_picks = true">
                                    <i class="fa fa-chevron-down"></i>
                                    <span>{{$t('scegli')}}:</span>
                                    <span class="text-lowercase ml-2" style="font-weight: normal; font-style: italic;"
                                          v-if="this.product.prodotto_composto_tipo_prezzo === 'VARIABILE' && this.standard_proportion.prezzo">
                                        {{$t('ordine.scegli')}} {{
                                            this.standard_proportion.prezzo.toFixedGood(2)
                                        }} {{this.locale_currency}}
                                    </span>
                                </button>
                            </div>
                            <div class="dati pb-0" v-for="(associated, i) in this.associated_combo_products">
                                <div class="border-top">
                                    <div class="d-flex align-items-center justify-content-between p-2">
                                        <span class="color">
                                            {{associated.nome_prodotto}} ({{$t('qta')}}: {{associated.qta}}
                                            <span v-if="associated.totale">
                                                / + {{associated.totale.toFixedGood(2)}} {{locale_currency}}
                                            </span>
                                            )
                                        </span>
                                        <i class="fa fa-times float-right mr-2" style="cursor: pointer;"
                                           @click="removeComboPick(i)"></i>
                                    </div>
                                    <div class="p-2 bg-light border-top" v-if="associated.ingredienti.length">
                                        <small v-for="(ingredient, i) in associated.ingredienti"
                                               :class="{'font-weight-bold': ingredient.hasOwnProperty('allergeni') && ingredient.allergeni.length}">
                                            {{
                                                ingredient.alias + (i === (associated.ingredienti.length - 1) ? "" :
                                                    ",")
                                            }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12" v-if="this.product.misure.length > 1">
                            <div class="dati">
                                <button class="btn btn-block" @click="show_modal_measures = true">
                                    <i class="fa fa-chevron-down"></i>
                                    <span>{{$t('ordine.misura')}}:</span>
                                    <span>{{this.current_proportion.nome}}</span>
                                    <span>
                                    ({{this.current_proportion.prezzo.toFixedGood(2)}} {{this.locale_currency}})
                                </span>
                                </button>
                            </div>
                        </div>

                        <div class="col-12" v-if="this.product.varianti.length">
                            <div class="dati">
                                <button class="btn btn-block" @click="show_modal_variants = true">
                                    <i class="fa fa-chevron-down"></i>
                                    <span v-if="this.product.variante_label">
                                    {{this.product.variante_label.toUpperCase()}}
                                    </span>
                                    <span v-else>{{$t('varianti')}}</span>
                                    :
                                    <span v-if="this.variante_obbligatoria_alert_state === 2">{{$t('select')}}</span>
                                    <span v-else-if="this.current_variant">
                                    {{this.current_variant.nome}}
                                        <span v-if="this.current_variant.prezzo !== undefined">
                                            {{this.current_variant.prezzo.toFixedGood(2)}} {{this.locale_currency}}
                                        </span>
                                    </span>
                                    <span v-else>{{$t('nessuna')}}</span>
                                </button>
                            </div>
                        </div>

                        <div class="w-100 gusti-container" v-if="this.current_free_picks.length">
                            <!-- scelte modifica -->
                            <div class="col-12" v-for="(free_pick, i) in this.current_free_picks">
                                <div class="dati">
                                    <button class="btn btn-block" @click="showModalFreePicks(free_pick, i)">
                                        <i class="fa fa-chevron-down"></i>
                                        <i class="fa fa-times mr-3" v-if="free_pick"
                                           @click.stop="removeFreePick(i)"></i>
                                        <span>{{(product.scelta_libera_label || $t('gusto')).toUpperCase()}} </span>
                                        <span>{{(i + 1)}}</span>:
                                        <span v-if="free_pick">{{free_pick.alias}}</span>
                                        <span v-else>{{$t('scegli')}}</span>
                                    </button>
                                </div>
                            </div>
                            <!-- fine scelte modifica-->
                        </div>

                        <div class="col-12" v-if="this.product_has_adds">
                            <div class="dati">
                                <button class="btn btn-block" @click="show_modal_adds = true">
                                    <i class="pi pi-plus"></i>
                                    <span> {{$t('agg_ingr')}}</span>
                                </button>
                                <ul class="aggiunte">
                                    <li v-for="(add, i) in this.current_adds">
                                        <i class="pi pi-times" style="cursor: pointer;" @click="removeAdd(add, i)"></i>
                                        <span>
                                        {{add.alias}} ({{add.variazione_prezzo.toFixedGood(2)}} {{
                                                locale_currency
                                            }})
                                    </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-12" v-if="this.max_quantity !== null">
                            <div class="dati border-top" style="padding:12px;"
                                 v-if="this.realtime_quantity > 10">
                                <b class="text-uppercase">
                                    {{$tc('more_than_availability', 10, {n: 10})}}
                                </b>
                            </div>
                            <div class="dati border-top" style="padding:12px;" v-else>
                                <b class="text-uppercase">{{$t('residual_availability')}}</b>
                                <div class="quantita">
                                    {{this.realtime_quantity}}
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="dati d-flex align-items-center justify-content-between border-top" style="padding: 12px;">
                                <b class="text-uppercase">{{$t('carrello.quantita')}}</b>
                                <div class="quantita">
                                    <button class="btn btn-circle" @click="removeQuantity">
                                        <i class="fa fa-minus"></i>
                                    </button>
                                    <span>{{this.quantity}}</span>
                                    <button class="btn btn-circle" @click="addQuantity"
                                            :disabled="this.realtime_quantity === 0">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="dati form-group p-3 border-top" style="margin:0;">
                            <textarea v-model="note" class="form-control" rows="3"
                                      :placeholder="$t('note')"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

              <inc-suggested-products :suggested-products="this.suggested_products"
                                      v-if="this.suggested_products.length"/>
            </div><!-- /.content-list -->
        </div>

        <div class="totale bg-black d-flex justify-content-between  align-items-center">
          <div class="white f2">
            <span>{{this.total_price.toFixedGood(2)}} {{this.locale_currency}}</span>
          </div>
          <button class="btn btn-primary w-auto mb-0" :disabled="this.isBlocked()" @click="submit()">
                  <span v-if="this.cart_item">
                      {{$t('btn_salva')}}
                  </span>
            <span v-else>
                      {{$t('ordine_salva_ordine_btn')}}
                  </span>
          </button>
        </div>


        <modal-legend :characteristics="this.product.caratteristiche" v-if="this.show_modal_legend"
                      @close="show_modal_legend = false"/>
        <modal-allergens :allergens="this.product_allergens" v-if="this.show_modal_allergens"
                         @close="show_modal_allergens = false"/>
        <modal-measure :product="this.product" :measure-id="this.current_price.id_misura_tipologia_prodotto"
                       v-if=this.show_modal_measures @close="hideModalMeasures"/>
        <modal-variants :product="this.product" :measure="this.current_proportion"
                        :variant-id="this.current_price.id_variante_tipologia_prodotto"
                        v-if="this.show_modal_variants"
                        @close="hideModalVariants"/>
        <modal-adds :adds="this.product.aggiunte" :current-adds="this.current_adds"
                    :measure-id="this.current_price.id_misura_tipologia_prodotto" v-if="this.show_modal_adds"
                    @close="hideModalAdds"/>
        <modal-free-picks :product="this.product" :current-free-picks="this.current_free_picks"
                          :measure-id="this.current_price.id_misura_tipologia_prodotto"
                          v-if="this.show_modal_free_picks"
                          @close="hideModalFreePicks"/>
        <modal-change-free-pick :product="this.product" :current-free-picks="this.current_free_picks"
                                :measure-id="this.current_price.id_misura_tipologia_prodotto"
                                :index="this.selected_free_pick_index"
                                v-if="this.show_modal_change_free_pick"
                                @close="hideModalChangeFreePick"/>
        <modal-out-of-stock-ingredients :ingredients="this.out_of_stock_ingredients"
                                        v-if="this.show_modal_out_of_stock_ingredients"
                                        @close="show_modal_out_of_stock_ingredients = false"/>
        <modal-combo-picks :categories="this.product.prodotto_composto_categorie_selezionabili"
                           :min_prod="this.product.prodotto_composto_min_prod"
                           :max_prod="this.product.prodotto_composto_max_prod"
                           :price-type="this.product.prodotto_composto_tipo_prezzo"
                           :associated="this.associated_combo_products" v-if="this.show_modal_combo_picks"
                           @close="hideModalComboPicks"/>
        <modal-removed-free-picks :free-picks="this.removed_free_picks" @close="hideModalRemovedFreePicks"
                                  v-if="this.show_modal_removed_free_picks"/>
        <modal-removed-adds :adds="this.removed_adds" @close="hideModalRemovedAdds"
                            v-if="this.show_modal_removed_adds"/>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';

import {getProduct} from '../../api/restaurant';
import {getCharacteristicIcon, getImage} from '../../api/core';
import {canAddProductInCombo} from '../../libraries/utils';

import ModalLegend from './partials/ModalLegend';
import ModalAllergens from './partials/ModalAllergens';
import ModalMeasure from './partials/ModalMeasure';
import ModalVariants from './partials/ModalVariants';
import ModalAdds from './partials/ModalAdds';
import ModalFreePicks from './partials/ModalFreePicks';
import ModalChangeFreePick from './partials/ModalChangeFreePick';
import ModalOutOfStockIngredients from './partials/ModalOutOfStockIngredients';
import IncSuggestedProducts from '../partials/IncSuggestedProducts';
import ModalComboPicks from './partials/ModalComboPicks';
import IncProductPriceLabel from './partials/IncProductPriceLabel';
import ModalRemovedFreePicks from './partials/ModalRemovedFreePicks';
import ModalRemovedAdds from './partials/ModalRemovedAdds';

export default {
    name: "Product",
    components: {
        ModalRemovedAdds,
        ModalRemovedFreePicks,
        IncProductPriceLabel,
        ModalComboPicks,
        IncSuggestedProducts,
        ModalOutOfStockIngredients,
        ModalChangeFreePick,
        ModalFreePicks,
        ModalAdds,
        ModalVariants,
        ModalMeasure,
        ModalAllergens,
        ModalLegend
    },
    data() {
        return {
            product: null,
            current_adds: [],
            current_free_picks: [],
            current_price: null,
            quantity: 1,
            note: '',

            //modifica
            initial_quantity: 0,
            //

            show_modal_legend: false,
            show_modal_allergens: false,
            show_modal_measures: false,
            show_modal_variants: false,
            show_modal_adds: false,
            show_modal_free_picks: false,
            show_modal_change_free_pick: false,
            current_tab: 'ingredients',
            selected_free_pick_index: null,

            error_title: '',

            show_modal_out_of_stock_ingredients: false,

            //combo implementation
            associated_combo_products: [],
            show_modal_combo_picks: false,
            images_index: 0,

            //remove addition/free picks implementation
            show_modal_removed_free_picks: false,
            show_modal_removed_adds: false,
            removed_free_picks: [],
            removed_adds: [],

            variante_obbligatoria_alert_state: 0
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        current_images: function () {
            return [getImage(this.language, this.id_ristorante, this.product.foto_codice)]
                .concat(this.associated_combo_products.reduce((accumulator, associated) => {
                    if (associated.foto_codice) {
                        accumulator.push(getImage(this.language, this.id_ristorante, associated.foto_codice));
                    }
                    return accumulator;
                }, []));
        },
        product_allergens: function () {
            let allergens = [];
            let allergens_ids = [];
            this.product.ingredienti.concat(
                this.current_adds,
                this.current_free_picks,
                this.associated_combo_products.reduce((accumulator, product) => {
                    return accumulator.concat(product.ingredienti);
                }, [])
            ).forEach((ingredient) => {
                if (ingredient) {
                    ingredient.allergeni.forEach((allergen) => {
                        if (!allergens_ids.includes(allergen.id)) {
                            allergens_ids.push(allergen.id);

                            allergen.ingredients = [];

                            allergens.push(allergen);
                        }

                        const idx = allergens.findIndex((obj) => {
                            return obj.id === allergen.id
                        });
                        if (idx >= 0) {
                            allergens[idx].ingredients.push(ingredient.alias);
                        }
                    });
                }
            });

          (this.product.allergeni_prodotto || []).forEach((allergen) => {
            if(!allergens_ids.includes(allergen.id)) {
              allergens_ids.push(allergen.id)
              allergens.push(allergen)
            }
          });

          this.associated_combo_products.forEach((product) => {
            (product.allergeni_prodotto || []).forEach((allergen) => {
              if (!allergens_ids.includes(allergen.id)) {
                allergens_ids.push(allergen.id);

                allergens.push({
                  ...allergen,
                  ingredients: []
                });
              }
            });
          });
            return allergens;
        },
        current_proportion: function () {
            const measure = this.product.misure.find((obj) => {
                return this.current_price.id_misura_tipologia_prodotto === obj.id;
            });

            //Prendiamo il primo prezzo disponibile
            const standardPrice = this.product.prezzi.find((obj) => {
                return this.current_price.id_misura_tipologia_prodotto === obj.id_misura_tipologia_prodotto;
            });

            let price = standardPrice.prezzo;
            if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(this.order.type)) {
                if (standardPrice.prezzo_kmenu) price = standardPrice.prezzo_kmenu;
            }

            return {
                id: measure.id,
                nome: measure.nome,
                prezzo: price
            };
        },
        standard_proportion: function () {
            //A quanto ne so la misura standard è sempre la prima
            const misura = this.product.misure[0];

            //Prendiamo il primo prezzo disponibile
            const prezzoStandard = this.product.prezzi.find((obj) => {
                return misura && obj.id_misura_tipologia_prodotto === misura.id;
            }) || this.product.prezzi[0];

            let price = prezzoStandard.prezzo;
            if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(this.order.type)) {
                if (prezzoStandard.prezzo_kmenu) price = prezzoStandard.prezzo_kmenu;
            }

            return {
                id: misura.id,
                nome: misura.nome,
                prezzo: price,
            };
        },
        current_variant() {
            if (this.product.varianti.length) {
                const variant = this.product.varianti.find((obj) => {
                    return this.current_price.id_variante_tipologia_prodotto === obj.id;
                });

                let price = this.current_price.prezzo;
                if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(this.order.type)) {
                    if (this.current_price.prezzo_kmenu) price = this.current_price.prezzo_kmenu;
                }

                if (variant) {
                    return {
                        id: variant.id,
                        nome: variant.nome,
                        prezzo: (price - this.current_proportion.prezzo)
                    };
                } else if (this.product.variante_nome) {
                    return {
                        id: null,
                        nome: this.product.variante_nome
                    };
                }
            }

            return null;
        },
        total_price: function () {
            let piece_price = 0;
            if (this.current_price) {
                piece_price = this.current_price.prezzo;
                if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(this.order.type)) {
                    if (this.current_price.prezzo_kmenu) piece_price = this.current_price.prezzo_kmenu;
                }
            }

            if (this.product && this.product.prodotto_composto_tipo_prezzo === 'VARIABILE') {
                piece_price = 0;
            }
            this.current_adds.forEach((item) => piece_price += item.variazione_prezzo);
            this.current_free_picks.forEach((item) => {
                if (item) {
                    piece_price += item.variazione_prezzo
                }
            });

            this.associated_combo_products.forEach((item) => {
                if (item) {
                    piece_price += item.prezzo * item.qta;
                }
            });

            return (piece_price * this.quantity);
        },
        max_quantity: function () {
            //NETFOOD
            try {
                if (this.product.quantita) {
                    const quantity = this.product.quantita.find((qt) => {
                        return qt.id_locale === this.locale.id
                    });

                    if (quantity) {
                        return quantity.quantita;
                    }
                }
                return null;
            } catch (e) {
                return null;
            }
        },
        current_quantity: function () {
            //NETFOOD
            try {
                if (this.product.quantita) {
                    const quantity = this.product.quantita.find((qt) => {
                        return qt.id_locale === this.locale.id
                    });

                    if (quantity) {
                        //Trovo anche la quantità di articoli già presenti dello stesso tipo
                        let current_quantity = 0;
                        this.order.items.forEach((item) => {
                            if (item.item.id === this.product.id) {
                                current_quantity += item.quantity;
                            }
                        });

                        //Se è un prodotto già aggiunto, sottraggo la quantità al current_quantity
                        if (this.cart_item) {
                            current_quantity -= this.initial_quantity;
                        }

                        return current_quantity;
                    }
                }
                return null;
            } catch (e) {
                return null;
            }
        },
        realtime_quantity: function () {
            //NETFOOD
            if (this.max_quantity !== null) {
                return this.max_quantity - this.current_quantity - this.quantity;
            }

            return null;
        },
        out_of_stock_ingredients: function () {
            return this.product.ingredienti.filter((ingredient) => {
                return !ingredient.f_disponibile || (ingredient.mask_locali_esclusi & this.locale.id);
            }).map((ingredient) => {
                return ingredient.alias;
            });
        },
        product_has_adds: function () {
            try {
                return !!this.product.aggiunte.ingredienti.length;
            } catch (e) {
                return false;
            }
        },
        cart_item: function () {
            if (this.$route.query.idx >= 0) {
                return this.order.items.find((item, i) => {
                    return i === parseInt(this.$route.query.idx);
                });
            }
            return null;
        },
        suggested_products: function () {
            try {
                return this.product.prodotti_suggeriti;
            } catch (e) {
                return [];
            }
        },
        can_add_associated_products() {
            let canStillAdd = false;

            if (this.product) {
                this.product.prodotto_composto_categorie_selezionabili.forEach((category) => {
                    if (canAddProductInCombo(
                        category,
                        this.associated_combo_products,
                        this.product.prodotto_composto_max_prod
                    )) {
                        canStillAdd = true;
                    }
                });
            }

            return canStillAdd;
        },
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapGetters('restaurant', {
            graphic_layout: 'graphicLayout',
            locale_currency: 'localeCurrency'
        })
    },
    watch: {
        language: function () {
            this.fetch();
        },
        $route: function (to, from) {
            if (from.name === to.name) {
                //reset data
                Object.assign(this.$data, this.$options.data.call(this));

                this.fetch();
            }
        }
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getProduct(this.language, {
                id_ristorante: this.id_ristorante,
                id_prodotto: this.$route.params.id,
                id_categoria_prodotto: this.$route.params.category_id,
                id_locale: this.locale.id,
                ultimo_aggiornamento: false//(mio_prodotto ? mio_prodotto.updated_at : false)
            }).then((response) => {
                    this.product = response.prodotto;

                    //modifica
                    if (this.cart_item) {
                        this.quantity = this.cart_item.quantity;
                        this.current_price = this.cart_item.item.price;
                        this.current_adds = [...this.cart_item.item.adds];
                        this.note = this.cart_item.item.note;
                        this.initial_quantity = this.cart_item.quantity;
                        this.current_free_picks = [...this.cart_item.item.free_picks];
                        this.associated_combo_products = [...this.cart_item.item.prodotto_composto_associati];
                    } else {
                        this.current_price = this.product.prezzi[0];

                        //sull'app è leggermente diverso, serve anche lo stato 1, qui basta lo stato 2 e 0
                        this.variante_obbligatoria_alert_state = (this.product.f_variante_obbligatoria && this.product.varianti.length) ? 2 : this.variante_obbligatoria_alert_state;
                    }

                    //Controlliamo che le aggiunte siano ancora tutte disponibili
                    let newAdditions = [];
                    let deletedAdditions = [];
                    if (this.product.aggiunte && this.current_adds) {
                        this.current_adds.forEach((current_add) => {
                            const dbAddition = this.product.aggiunte.ingredienti.find((ingrediente) => {
                                return ingrediente.id === current_add.id && ingrediente.id_gruppo_aggiunte === current_add.id_gruppo_aggiunte;
                            });

                            if (dbAddition && !(dbAddition.mask_locali_esclusi & this.locale.id)) {
                                newAdditions.push(current_add);
                            } else {
                                deletedAdditions.push(current_add);
                            }
                        });
                    }

                    //Controlliamo che le aggiunte siano ancora tutte disponibili
                    let newFreePicks = [];
                    let deletedFreePicks = [];
                    if(this.product.scelte_libere.hasOwnProperty("ingredienti")){
                        if (this.current_free_picks) {
                            this.current_free_picks.filter((current_free_pick) => {
                                return current_free_pick !== null;
                            })
                                .forEach((current_free_pick) => {
                                    let dbFreePick = this.product.scelte_libere.ingredienti.find((ingrediente) => {
                                        return ingrediente.id === current_free_pick.id && ingrediente.id_gruppo_aggiunte === current_free_pick.id_gruppo_aggiunte;
                                    });

                                    if (dbFreePick && !(dbFreePick.mask_locali_esclusi & this.locale.id)) {
                                        newFreePicks.push(current_free_pick);
                                    } else {
                                        deletedFreePicks.push(current_free_pick);
                                    }
                                });
                        }

                        //Free picks
                        if (this.product.max_scelte_libere) {
                            newFreePicks = newFreePicks.slice(0, this.product.max_scelte_libere);
                            for (let i = newFreePicks.length; i < this.product.max_scelte_libere; i++) {
                                newFreePicks.push(null);
                            }
                        }
                    }

                    this.current_free_picks = newFreePicks;
                    this.current_adds = newAdditions;

                    this.removed_free_picks = deletedFreePicks.map((freePick) => freePick.alias).filter((v, i, a) => a.indexOf(v) === i);
                    this.removed_adds = deletedAdditions.map((add) => add.alias).filter((v, i, a) => a.indexOf(v) === i);

                    if (this.removed_free_picks.length || this.removed_adds.length) {
                        if (this.removed_adds.length) {
                            this.show_modal_removed_adds = true;
                        } else {
                            this.show_modal_removed_free_picks = true;
                        }
                    } else {
                        //check ingredienti non disponibili
                        if (this.out_of_stock_ingredients.length) {
                            this.show_modal_out_of_stock_ingredients = true;
                        }
                    }

                    //check quantità prodotto (NETFOOD)
                    const outOfStock = (this.max_quantity !== null && this.current_quantity >= this.max_quantity);

                    if (outOfStock && !this.cart_item) {
                        this.quantity = 0;
                        this.showModalErrors({
                            title: this.$t('menu').toUpperCase(),
                            errors: [this.$t('no_more_availability')]
                        });
                    }

                    if (!this.product.ingredienti.length && this.product_allergens.length) {
                        this.current_tab = 'allergens';
                    }
                }
            ).catch((messages) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        getCharacteristicIcon: function (characteristic) {
            return getCharacteristicIcon(this.language, characteristic.icona);
        },
        hideModalMeasures: function (proportion_id) {
            if (proportion_id) {
                if (this.current_price.id_misura_tipologia_prodotto !== proportion_id) {
                    this.updateCurrentPrice(proportion_id);
                }
            }

            this.show_modal_measures = false;
        },
        hideModalVariants: function (variant_id) {
            if (variant_id >= 0) {
                if (this.current_price.id_variante_tipologia_prodotto !== variant_id) {
                    this.updateCurrentPrice(this.current_proportion.id, variant_id ? variant_id : null);
                }

                this.variante_obbligatoria_alert_state = 0;
            }

            this.show_modal_variants = false;
        },
        hideModalAdds: function (current_adds) {
            if (current_adds) {
                this.current_adds = current_adds;
            }

            this.show_modal_adds = false;
        },
        getConfiguredAddPrice: function (add, measureId) {
            const override = (add.misure_prezzi_override || []).find((obj) => {
                return obj.id_misura_tipologia_prodotto === measureId;
            });

            if (override) {
                return override.prezzo;
            }

            const groupMeasure = (this.product.aggiunte.misure_gruppi || []).find((obj) => {
                return obj.id_misura_tipologia_prodotto === measureId &&
                    obj.id_gruppo_aggiunte === add.id_gruppo_aggiunte;
            });

            if (groupMeasure) {
                return groupMeasure.variazione_prezzo;
            }

            return add.variazione_prezzo_originale !== undefined && add.variazione_prezzo_originale !== null
                ? add.variazione_prezzo_originale
                : add.variazione_prezzo;
        },
        normalizeCurrentGroupAddPrices: function (group) {
            const freeAdds = Number(group.aggiunte_gratis) || 0;
            let normalizedFreeAdds = 0;

            this.current_adds = this.current_adds.map((current_add) => {
                if (current_add.id_gruppo_aggiunte !== group.id) {
                    return current_add;
                }

                const normalizedAdd = {...current_add};
                normalizedAdd.variazione_prezzo = normalizedFreeAdds < freeAdds
                    ? 0
                    : this.getConfiguredAddPrice(
                        normalizedAdd,
                        this.current_price.id_misura_tipologia_prodotto
                    );
                normalizedFreeAdds++;

                return normalizedAdd;
            });
        },
        updateCurrentPrice: function (proportion_id, variant_id) {
            //Prendiamo il primo prezzo disponibile
            this.current_price = this.product.prezzi.find((obj) => {
                let found = true;
                if (proportion_id) {
                    found = proportion_id === obj.id_misura_tipologia_prodotto;
                }

                if (found && variant_id) {
                    found = (variant_id === obj.id_variante_tipologia_prodotto);
                }

                return found;
            });

            let adds_filtered = [];
            if (this.current_adds.length) {
                this.current_adds.forEach((add) => {
                    const groupMeasure = this.product.aggiunte.misure_gruppi.find((obj) => {
                        return (obj.id_misura_tipologia_prodotto === proportion_id && obj.id_gruppo_aggiunte === add.id_gruppo_aggiunte);
                    });

                    if (groupMeasure) {
                        let updatedAdd = {...add};

                        //Cerco se esiste un'override del prezzo
                        const override = (updatedAdd.misure_prezzi_override || []).find((obj) => {
                            return (obj.id_misura_tipologia_prodotto === proportion_id);
                        });

                        const configuredPrice = override ? override.prezzo : groupMeasure.variazione_prezzo;
                        updatedAdd.variazione_prezzo = configuredPrice;
                        updatedAdd.variazione_prezzo_originale = configuredPrice;
                        updatedAdd.f_override = !!override;

                        //Controllo se non ha superato il max_aggiunte per questa misura
                        let groupsAdds = adds_filtered.filter((filtered_add) => {
                            return filtered_add.id_gruppo_aggiunte === groupMeasure.id_gruppo_aggiunte;
                        });

                        if (groupMeasure.max_aggiunte && groupsAdds.length >= groupMeasure.max_aggiunte) {
                            return;
                        }

                        if (groupMeasure.aggiunte_gratis) {
                            if (groupsAdds.length < (Number(groupMeasure.aggiunte_gratis) || 0)) {
                                updatedAdd.variazione_prezzo = 0;
                            }
                        }

                        adds_filtered.push(updatedAdd);
                    }
                });
            }

            this.current_adds = adds_filtered;
        },
        addQuantity: function () {
            if (this.max_quantity !== null) {
                if (this.current_quantity + (this.quantity + 1) <= this.max_quantity) {
                    this.quantity += 1;
                }
            } else {
                this.quantity += 1;
            }
        },
        removeQuantity: function () {
            if (this.quantity > 0) {
                this.quantity -= 1;
            }
        },
        removeAdd: function (add, i) {
            this.current_adds.splice(i, 1);

            let group = this.product.aggiunte.gruppi.find((group) => {
                return group.id === add.id_gruppo_aggiunte;
            });

            const groupMeasure = this.product.aggiunte.misure_gruppi.find((obj) => {
                return (obj.id_misura_tipologia_prodotto === this.current_price.id_misura_tipologia_prodotto && obj.id_gruppo_aggiunte === group.id);
            });

            if (groupMeasure) {
                group.max_aggiunte = groupMeasure.max_aggiunte;
                group.aggiunte_gratis = groupMeasure.aggiunte_gratis;
            }

            if (group && group.aggiunte_gratis) {
                this.normalizeCurrentGroupAddPrices(group);
            }
        },
        hideModalFreePicks: function (picks) {
            if (picks) {
                let current_free_picks = [...this.current_free_picks];

                current_free_picks.forEach((item_free_pick, index_free_pick) => {
                    if (!item_free_pick && picks.length) {
                        current_free_picks[index_free_pick] = picks.shift();
                    }
                });

                this.current_free_picks = current_free_picks;
            }

            this.show_modal_free_picks = false;
        },
        removeFreePick: function (index) {
            this.current_free_picks.splice(index, 1);
            this.current_free_picks.push(null);
        },
        showModalFreePicks: function (free_pick, index) {
            if (free_pick) {
                this.selected_free_pick_index = index;
                this.show_modal_change_free_pick = true;
            } else {
                this.show_modal_free_picks = true;
            }
        },
        hideModalChangeFreePick: function (free_pick) {
            if (free_pick) {
                this.current_free_picks.splice(this.selected_free_pick_index, 1, free_pick);
            }
            this.show_modal_change_free_pick = false;
        },
        hideModalComboPicks: function (picked) {
            if (picked) {
                this.associated_combo_products = picked;
                if (!this.product.ingredienti.length && this.product_allergens.length) {
                    this.current_tab = 'allergens';
                }
            }
            this.show_modal_combo_picks = false;
        },
        removeComboPick: function (index) {
            const associated = this.associated_combo_products.slice();
            associated.splice(index, 1);
            this.associated_combo_products = associated;


            if (this.images_index && this.current_images.length < (this.images_index + 1)) {
                this.images_index -= 1;
            }
        },
        hideModalRemovedFreePicks: function () {
            this.show_modal_removed_free_picks = false;
            this.removed_free_picks = [];

            //check ingredienti non disponibili
            if (this.out_of_stock_ingredients.length) {
                this.show_modal_out_of_stock_ingredients = true;
            }
        },
        hideModalRemovedAdds: function () {
            this.show_modal_removed_adds = false;
            this.removed_adds = [];

            //check ingredienti non disponibili
            if (this.out_of_stock_ingredients.length) {
                this.show_modal_out_of_stock_ingredients = true;
            }
        },
        isBlocked: function () {
            if (this.max_quantity === null) {
                return false;
            } else {
                if (this.cart_item) {
                    return false;
                } else {
                    if (this.max_quantity - this.current_quantity <= 0) {
                        return true;
                    } else {
                        return (this.max_quantity - this.current_quantity - this.quantity) < 0;
                    }
                }
            }
        },
        submit: function () {
            const choosenFreePicksNumber = this.current_free_picks.filter((pick) => pick).length;

            if (this.quantity !== 0 && this.product.scelte_libere.hasOwnProperty("ingredienti") && this.product.min_scelte_libere && choosenFreePicksNumber < this.product.min_scelte_libere) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: [
                        this.$tc('min_free_picks_alert', this.product.min_scelte_libere, {n: this.product.min_scelte_libere})
                    ]
                });
            } else {
                let goOn = true;

                if (this.variante_obbligatoria_alert_state === 2) {
                    this.showModalErrors({
                        title: this.$t('attenzione_label').toUpperCase(),
                        errors: [
                            this.$t('variante_obbligatoria_alert', {etichetta: this.product.variante_label
                                    ? this.product.variante_label.toUpperCase()
                                    : this.$t('ordine.variante_titolo').toUpperCase()})
                        ]
                    });

                    goOn = false;
                }

                //Controllo se c'è min_aggiunte da verificare
                if (this.product.aggiunte && this.product.aggiunte.gruppi && this.product.aggiunte.misure_gruppi) {
                    let stopWithAggiunteError = null;

                    this.product.aggiunte.gruppi.forEach((gruppo) => {
                        const misura_gruppo =
                            this.product.aggiunte.misure_gruppi.find(obj => {
                                return (
                                    obj.id_misura_tipologia_prodotto ===
                                    this.current_price
                                        .id_misura_tipologia_prodotto &&
                                    obj.id_gruppo_aggiunte === gruppo.id
                                );
                            });

                        if (misura_gruppo && misura_gruppo.min_aggiunte) {
                            const totalAggiunteGruppo = this.current_adds.filter(current_add => current_add.id_gruppo_aggiunte === gruppo.id).length;

                            if (totalAggiunteGruppo < misura_gruppo?.min_aggiunte) {
                                stopWithAggiunteError = (misura_gruppo.min_aggiunte > 1 ? this.$t('min_aggiunte_necessarie_plur') : this.$t('min_aggiunte_necessarie_sing')).replace("{MIN_AGGIUNTE}", misura_gruppo.min_aggiunte).replace("{GRUPPO}", gruppo.nome);

                                goOn = false;
                            }
                        }
                    });

                    if (stopWithAggiunteError) {
                        this.showModalErrors({
                            title: this.$t('attenzione_label').toUpperCase(),
                            errors: [stopWithAggiunteError]
                        });

                        goOn = false;
                    }
                }

                if (this.product.f_prodotto_composto) {
                    const comboErrors = [];
                    const minimumComboProducts = this.product.prodotto_composto_min_prod;
                    const totalComboProducts = this.associated_combo_products.reduce((accumulator, associated) => {
                        return accumulator + associated.qta;
                    }, 0);
                    let globalError = false;
                    let firstCategoryError = true;

                    if (minimumComboProducts && totalComboProducts < minimumComboProducts) {
                        comboErrors.push(this.$tc('alert_combo_picks_min_prod', minimumComboProducts));
                        globalError = true;
                    }

                    this.product.prodotto_composto_categorie_selezionabili.forEach((category) => {
                        const minimumCategoryProducts = category.min_prod_selezionabili;

                        if (!minimumCategoryProducts) {
                            return;
                        }

                        const totalCategoryProducts = this.associated_combo_products.reduce((accumulator, associated) => {
                            if (associated.id_categoria === category.id_categoria) {
                                return accumulator + associated.qta;
                            }

                            return accumulator;
                        }, 0);

                        if (totalCategoryProducts < minimumCategoryProducts) {
                            let error = '';
                            if (globalError) {
                                if (firstCategoryError) {
                                    error += this.$t('di_cui') + ' ';
                                    firstCategoryError = false;
                                }

                                error += this.$tc('n_prodotti', minimumCategoryProducts) + ' ';
                            } else {
                                error += this.$tc('alert_combo_picks_min_prod', minimumCategoryProducts) + ' ';
                            }

                            error += this.$t('della_categoria', {category: category.nome_categoria});
                            comboErrors.push(error);
                        }
                    });

                    if (comboErrors.length) {
                        this.showModalErrors({
                            title: this.$t('attenzione_label').toUpperCase(),
                            errors: comboErrors
                        });

                        goOn = false;
                    } else if (this.product.prodotto_composto_tipo_prezzo === 'VARIABILE' && (this.total_price < this.current_proportion.prezzo)) {
                        //Se è variabile, controllo costo minimo
                        this.showModalErrors({
                            title: this.$t('attenzione_label').toUpperCase(),
                            errors: [
                                this.$t('soglia_minima_prodotto') + " " + this.current_proportion.prezzo.toFixedGood(2) + " " + this.locale_currency
                            ]
                        });

                        goOn = false;
                    }
                }

                if (goOn) {
                    if (this.cart_item) {
                        this.deepModifyOrderItem({
                            initial_item: this.cart_item.item,
                            price: this.current_price,
                            adds: this.current_adds,
                            note: this.note,
                            quantity: this.quantity,
                            proportion: this.current_proportion,
                            standard_proportion: this.standard_proportion,
                            variant: this.current_variant,
                            free_picks: this.current_free_picks,
                            prodotto_composto_associati: this.associated_combo_products
                        });

                        this.$router.push({name: 'cart'});
                    } else {
                        if (this.quantity) {
                            this.modifyOrderItem({
                                item: {
                                    id: this.product.id,
                                    id_tipologia_prodotto: this.product.id_tipologia_prodotto,
                                    price: this.current_price,
                                    adds: this.current_adds,
                                    free_picks: this.current_free_picks,
                                    note: this.note,
                                    nome: this.product.nome,
                                    proportion: this.current_proportion,
                                    standard_proportion: this.standard_proportion,
                                    variant: this.current_variant,
                                    category_id: this.$route.params.category_id,
                                    f_sconto: this.product.f_sconto,
                                    f_prodotto_composto: this.product.f_prodotto_composto,
                                    prodotto_composto_tipo_prezzo: this.product.prodotto_composto_tipo_prezzo,
                                    prodotto_composto_associati: this.associated_combo_products,
                                },
                                quantity: this.quantity - this.initial_quantity,
                                menu_presenti: this.product.menu_presenti,
                                f_delivery: this.product.f_delivery,
                                prodotti_suggeriti: this.product.prodotti_suggeriti
                            });

                            this.$router.push({
                                name: 'menu.category.products',
                                params: {id: this.$route.params.category_id}
                            });
                        }
                        //}
                    }
                }
            }
        },
        ...mapActions('global', [
            'showLoading',
            'showModalErrors'
        ]),
        ...mapActions('order', {
            modifyOrderItem: 'modifyItem',
            deepModifyOrderItem: 'deepModifyItem'
        })
    }
}
</script>
